import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '~/components/layout';
import { CtaBanner } from '~/components/sections';
import { CareersHero } from '~/components/sections/CareersHero';
import {
  CareersLifeSection,
  CareersOpenPositions,
} from '~/components/sections/CareersOpenPositions';
import { careersLife, careersMeta } from '~/content/careers';
import { getJobs } from '~/lib/payload';
import { pageHeadMeta } from '~/lib/seo';

export const Route = createFileRoute('/careers')({
  loader: () => getJobs(),
  head: () =>
    pageHeadMeta({
      title: careersMeta.title,
      description: careersMeta.description,
      path: '/careers',
    }),
  component: CareersPage,
});

function CareersPage() {
  const jobs = Route.useLoaderData();

  return (
    <PageShell>
      <CareersHero />
      <CareersOpenPositions jobs={jobs} />
      <CareersLifeSection
        title={careersLife.title}
        paragraphs={careersLife.paragraphs}
        closing={careersLife.closing}
      />
      <CtaBanner />
    </PageShell>
  );
}
